module.exports = __webpack_public_path__ + "img/trust-icon.8859e3b6.svg";